<script>
  import { ui } from '../lib/stores/ui.svelte.js';

  const baseSteps = [
    { sel: '[data-walk="spark"]',    title: 'Spark',    body: "Quick observations or ideas. Parsed into audiences, offers, and insights." },
    { sel: '[data-walk="imagine"]',  title: 'Imagine',  body: "Describe your full vision. Elvie writes it up as a vision and can turn it into routes." }
  ];

  const steps = [...baseSteps, { sel: '[data-walk="url"]', title: 'Your site', body: 'Paste your site address — Elvie reads the page and drafts who it is for and what it offers.' }];

  let active = $state(false);
  let stepIdx = $state(0);
  let popoverPos = $state({ top: 0, left: 0 });

  function start() {
    active = true;
    stepIdx = 0;
    requestAnimationFrame(positionPopover);
  }

  function next() {
    if (stepIdx < steps.length - 1) {
      stepIdx++;
      requestAnimationFrame(positionPopover);
    } else {
      end();
    }
  }

  function end() {
    active = false;
    try { localStorage.setItem('bb_create_walkthrough_seen', '1'); } catch {}
  }

  function positionPopover() {
    const step = steps[stepIdx];
    if (!step) return;
    const el = document.querySelector(step.sel);
    if (!el) { next(); return; }
    const rect = el.getBoundingClientRect();
    popoverPos = {
      top: rect.bottom + 8 + window.scrollY,
      left: rect.left + rect.width / 2 + window.scrollX
    };
  }

  $effect(() => {
    let seen = false;
    try { seen = !!localStorage.getItem('bb_create_walkthrough_seen'); } catch {}
    if (!seen) setTimeout(() => start(), 400);
  });
</script>

<button class="walkthrough-replay" onclick={start} title="Walkthrough" type="button">?</button>

{#if active}
  {@const step = steps[stepIdx]}
  <div class="walk-overlay" onclick={end}></div>
  <div class="walk-popover" style="top: {popoverPos.top}px; left: {popoverPos.left}px;" onclick={(e) => e.stopPropagation()}>
    <div class="walk-arrow"></div>
    <div class="walk-step-num">{stepIdx + 1} / {steps.length}</div>
    <h4 class="walk-title">{step.title}</h4>
    <p class="walk-body">{step.body}</p>
    <div class="walk-actions">
      <button class="walk-skip" onclick={end} type="button">Skip</button>
      <button class="walk-next" onclick={next} type="button">{stepIdx === steps.length - 1 ? 'Done' : 'Next'}</button>
    </div>
  </div>
{/if}

<style>
  .walkthrough-replay {
    position: fixed; bottom: 24px; left: 24px;
    width: 36px; height: 36px; border-radius: 50%;
    background: #ffffff; color: #0a0a0c;
    border: none; cursor: pointer;
    font-size: 18px; font-weight: 600;
    box-shadow: 0 4px 14px rgba(0,0,0,0.4);
    z-index: 30;
  }
  .walkthrough-replay:hover { transform: scale(1.05); }
  .walk-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.5);
    z-index: 100;
  }
  .walk-popover {
    position: absolute;
    transform: translateX(-50%);
    background: #0a0a0c;
    border: 1px solid rgba(212,175,55,0.4);
    border-radius: 12px;
    padding: 16px;
    width: 280px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.7);
    z-index: 101;
  }
  .walk-arrow {
    position: absolute;
    top: -7px; left: 50%; transform: translateX(-50%) rotate(45deg);
    width: 12px; height: 12px;
    background: #0a0a0c;
    border-top: 1px solid rgba(212,175,55,0.4);
    border-left: 1px solid rgba(212,175,55,0.4);
  }
  .walk-step-num {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9px; letter-spacing: 1.4px; text-transform: uppercase;
    color: #9aa0a6;
    margin-bottom: 6px;
  }
  .walk-title {
    margin: 0 0 8px;
    font-family: 'DM Serif Display', serif; font-size: 18px;
    color: #f0efe9;
  }
  .walk-body {
    margin: 0 0 14px;
    color: #d8d8dc; font-size: 13px;
    line-height: 1.5;
  }
  .walk-actions { display: flex; justify-content: space-between; gap: 8px; }
  .walk-skip {
    background: rgba(255,255,255,0.05); color: #b8b8bc;
    border: 1px solid rgba(255,255,255,0.1);
    padding: 6px 14px; border-radius: 6px;
    cursor: pointer; font-size: 12px;
  }
  .walk-next {
    background: linear-gradient(180deg, #d4af37, #b8941f); color: #0a0a0c;
    border: none;
    padding: 6px 16px; border-radius: 6px;
    cursor: pointer; font-weight: 600; font-size: 12px;
  }
</style>
